export const adminsColumns = (t: any) => [
    {
      key: "lastName",
      name: t('admins.columns.lastName'),
      fieldName: "lastName",
      minWidth: 100,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "firstName",
      name: t('admins.columns.firstName'),
      fieldName: "firstName",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "email",
      name: t('admins.columns.email'),
      fieldName: "email",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "phone",
      name: t('admins.columns.phone'),
      fieldName: "phone",
      minWidth: 100,
      maxWidth: 300,
    },
  ];